import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { getStatusMessage } from '../../utils/response-code-messages';
import Snackbar from '../../common/snackBar';
import get from 'lodash/get';
import { ComponentDataRequestActionTypes, SearchtActionTypes } from '../models/component-master';

const page_name = 'componentMaster';
interface Service {
  id: string | number;
  component_id: string | number;
  services: number;
  displayName: string;
  age: number;
}
export interface ComponentMasterState {
  isComponentMasterDataLoading: boolean;
  componentMasterData: Array<Service>;
  componentMasterDataTotalRowCount: number;
  componentMasterDataPageNumber: number;
  componentMasterDataError: boolean;
  isAddServiceLoading: boolean;
  isAddComponentSuccess: boolean;
  isAddComponentError: boolean;
  isUpdateServiceLoading: boolean;
  isUpdateServiceSuccess: boolean;
  isUpdateServiceError: boolean;
  isRemoveServiceLoading: boolean;
  isRemoveServiceSuccess: boolean;
  isRemoveServiceError: boolean;
  componentMessage: string;
  searchItem: undefined | string;
}

const initialState: ComponentMasterState = {
  isComponentMasterDataLoading: false,
  componentMasterData: [],
  componentMasterDataTotalRowCount: 0,
  componentMasterDataPageNumber: 1,
  componentMasterDataError: false,
  isAddServiceLoading: false,
  isAddComponentSuccess: false,
  isAddComponentError: false,
  isUpdateServiceLoading: false,
  isUpdateServiceSuccess: false,
  isUpdateServiceError: false,
  isRemoveServiceLoading: false,
  isRemoveServiceSuccess: false,
  isRemoveServiceError: false,
  componentMessage: '',
  searchItem: '',
};

const componentMasterReducer = createSlice({
  name: page_name,
  initialState: initialState,
  reducers: {
    getServicesDataRequest: (state, action: ComponentDataRequestActionTypes) => {
      state.isComponentMasterDataLoading = true;
      state.isAddComponentSuccess = false;
      state.isUpdateServiceSuccess = false;
      state.isRemoveServiceSuccess = false;
    },
    getServicesDataResponse: (state, action) => {
      state.isComponentMasterDataLoading = false;
      if (state.searchItem === get(action, 'payload.res.search_item', '')) {
        state.componentMasterData = get(action, 'payload.res.data', []);
        state.componentMasterDataTotalRowCount = get(action, 'payload.res.total_count', 0);
        state.componentMasterDataPageNumber = get(action, 'payload.res.page', 0);
      }
    },
    getServicesDataFailed: (state, action: any) => {
      state.isComponentMasterDataLoading = false;
      state.componentMasterDataError = true;
      state.componentMasterData = [];

      const message = getStatusMessage(page_name, action.payload);
      state.componentMessage = message;
      Snackbar.error(message);
    },
    addServiceRequest: (state) => {
      state.isComponentMasterDataLoading = true;
      state.isAddServiceLoading = true;
      state.isAddComponentSuccess = false;
      state.isAddComponentError = false;
    },
    addServiceResponse: (state, action) => {
      state.isComponentMasterDataLoading = false;
      state.isAddServiceLoading = false;
      state.isAddComponentSuccess = true;

      const message = getStatusMessage(page_name, action.payload);
      state.componentMessage = message;
      Snackbar.success(message);
    },
    addServiceFailed: (state, action: any) => {
      state.isComponentMasterDataLoading = false;
      state.isAddServiceLoading = false;
      state.isAddComponentError = true;

      const message = getStatusMessage(page_name, action.payload);
      state.componentMessage = message;
      Snackbar.error(message);
    },
    updateServiceRequest: (state) => {
      state.isComponentMasterDataLoading = true;
      state.isUpdateServiceLoading = true;
      state.isUpdateServiceSuccess = false;
      state.isUpdateServiceError = false;
    },
    updateServiceResponse: (state, action: any) => {
      state.isComponentMasterDataLoading = false;
      state.isUpdateServiceLoading = false;
      state.isUpdateServiceSuccess = true;

      const message = getStatusMessage(page_name, action.payload);
      state.componentMessage = message;
      Snackbar.success(message);
    },
    updateServiceFailed: (state, action: any) => {
      state.isComponentMasterDataLoading = false;
      state.isUpdateServiceLoading = false;
      state.isUpdateServiceError = true;
      state.isUpdateServiceSuccess = false;

      const message = getStatusMessage(page_name, action.payload);
      state.componentMessage = message;
      Snackbar.error(message);
    },
    removeServiceRequest: (state, action: any) => {
      state.isRemoveServiceLoading = true;
      state.isComponentMasterDataLoading = true;
      state.isRemoveServiceSuccess = false;
      state.isRemoveServiceError = false;
    },
    removeServiceResponse: (state, action: any) => {
      state.isRemoveServiceLoading = false;
      state.isRemoveServiceSuccess = true;
      state.isComponentMasterDataLoading = false;
      state.isRemoveServiceError = false;

      const message = getStatusMessage(page_name, action.payload);
      state.componentMessage = message;
      Snackbar.success(message);
    },
    removeServiceFailed: (state, action: any) => {
      state.isRemoveServiceLoading = false;
      state.isRemoveServiceError = true;
      state.isComponentMasterDataLoading = false;
      state.isRemoveServiceSuccess = false;

      const message = getStatusMessage(page_name, action.payload);
      state.componentMessage = message;
      Snackbar.error(message);
    },
    resetLoadingState: (state) => {
      state.isAddComponentSuccess = false;
      state.isUpdateServiceError = false;
      state.isUpdateServiceSuccess = false;
      state.isAddComponentError = false;
      state.isRemoveServiceSuccess = false;
      state.isRemoveServiceError = false;
      state.componentMessage = '';
      state.componentMasterDataError = false;
    },
    resetComponentMasterData: (state) => {
      state.componentMasterData = [];
      state.componentMasterDataTotalRowCount = 0;
      state.componentMasterDataPageNumber = 1;
      state.searchItem = '';
    },
    onSearchForItem: (state, action: SearchtActionTypes) => {
      state.searchItem = action.payload;
    },
  },
});

export const componentMasterActions = componentMasterReducer.actions;
export default componentMasterReducer;
